import { render, staticRenderFns } from "./ClubPagesContainer.vue?vue&type=template&id=1e6e6081"
import script from "./ClubPagesContainer.vue?vue&type=script&lang=js"
export * from "./ClubPagesContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports